import { motion } from 'framer-motion';

export function LoadingScreen() {
  return (
    <div className="flex h-screen items-center justify-center bg-brand-smoke">
      <motion.div
        className="flex flex-col items-center gap-4"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <div className="relative">
          <div className="h-16 w-16 rounded-full border-4 border-brand-gold/20" />
          <motion.div
            className="absolute inset-0 h-16 w-16 rounded-full border-4 border-brand-gold border-t-transparent"
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
          />
        </div>
        <p className="font-serif text-brand-gold">Carregando...</p>
      </motion.div>
    </div>
  );
}